import React, { Component } from 'react';
import Head from 'next/head';

import { pages } from '../content.json';

class About extends Component {

  render(){

		const { about } = pages;

		return(

			<div>

				<Head>
					<meta name="description" content={ about.meta.description } />
					<title>{ about.meta.title }</title>
				</Head>

				<div className="about">

					<div className="about-header">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<h1>{ about.title }</h1>
								</div>
							</div>
						</div>
					</div>

					<div className="about-body">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									{
										about.content.map( ( item, index ) =>
										<p key={ index }>{ item }</p>
										)
									}
								</div>
								<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-1">
									<img src="/static/amanda-jacket.jpg" alt="" />
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>

		);

	}

}

export default About;
